import { render } from "./addFamily.vue?vue&type=template&id=68907496&scoped=true"
import script from "./addFamily.vue?vue&type=script&lang=js"
export * from "./addFamily.vue?vue&type=script&lang=js"

import "./addFamily.vue?vue&type=style&index=0&id=68907496&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68907496"]])

export default __exports__